// extracted by mini-css-extract-plugin
export default {"container":"container-z4hIJ","headingWrapper":"headingWrapper-oUjDq","heading":"heading-mLi4l","icon":"icon-Jsb1v"};